<template>
    <div class="pc-big-star">
        <div class="pchome-headerss top-header ">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>

        <position-bar :productc_nav="producthea_nav" :positionNav="positionNav">

        </position-bar>

        <div style="padding:10px 0;opacity:0" v-if="producthea_nav">
            <div class="videohea-left">
                {{title}}
            </div>
        </div>
        <div class="linesd"></div>

        <div class="productfoo">
            <div class="productfoo-shop">
                <div class="productfoo-item" v-for="(ite,inde) in videos.list" :key="inde" >
<!--                    <div class="shop-video"  @mouseleave="video_out(ite)" @mouseenter="video_in(ite)" @click="video_play_click(ite)">-->
<!--                        <video-player class="video-player vjs-custom-skin vjs-has-started" :style="{opacity:ite.playVideo ? 1 : 0}" style="transition: all 1s linear 0s;"-->
<!--                                      :ref="'videoPlayer'+ite.id"-->
<!--                                      :playsinline="true"-->
<!--                                      :options="ite.option"-->
<!--                        >-->
<!--                        </video-player>-->
<!--                        <img :src="ite.image" class="video_title_image" :style="{opacity:ite.playVideo ? 0 : 1}" style="transition: all 1s linear 0s;">-->
<!--                    </div>-->
<!--                    <div class="shop-icon" >-->
<!--                        <div class="shopicon-left">-->
<!--                            {{ite.title}}-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="shop-video">
<!--                        <iframe class="you-video" :src="'https://www.youtube.com/embed/'+ ite.video_id " :title="ite.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>-->
<!--                        <div class="poster" v-if="!ite.isPlay" @click="playVideo(ite)">-->
<!--                            <img class="play" src="../../assets/common/img/play.png" alt="">-->
<!--                            <img :src="ite.poster" alt="" >-->
<!--                        </div>-->
<!--                        <iframe v-else class="you-video" :src="ite.video" :title="ite.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>-->
<!--                        <div class="shop-icon" >-->
<!--                            <div class="shopicon-left" @click="learnMore(ite)">-->
<!--                                {{ite.title}}-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="poster" @click="learnMore(ite)">
                            <img class="play" :src="require('../../assets/common/img/play.png')" alt="">
                            <img :src="ite.poster" alt="" >
                        </div>
                        <div class="shop-icon" >
                            <div class="shopicon-left" @click="learnMore(ite)">
                                {{ite.title}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="bottom" class="bottom" >
        </div>
        <footers ref="is_change" ></footers>
    </div>
</template>

<script>
    import 'lib-flexible/flexible.js'
    import {session} from '../../storage/storage.js';
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
    import positionBar from '../../components/position-bar.vue'
    import 'videojs-contrib-hls'
    import myVideo from '../../common/myvideo/img/myVideo.vue'
    import utils from '../../api/utils.js'


    export default {
        name: "pc-big-star",
        data(){
            return {
                producthea_nav:false,
                nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
                videoclassallss:[],
                title:'视频',
                videotopnavind:0,
                videos:{
                    list:[],
                    page:{
                        current_page:1,
                        last_page:1,
                    },
                    loading:false,

                },
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'Top Talk',
                        path:'',
                    },
                ],

            }
        },
        components:{
            headers,
            footers,
            positionBar,
            myVideo
        },
        watch:{
            '$route': 'getParams'
        },
        mounted() {

            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                console.log('手机手机21321321')

                this.$router.push({path:'ph-big-star'})
            }

            sessionStorage.setItem('page',JSON.stringify({name:'pc-big-star',data:false}))

        },
        created() {
            // this.videoclassall()

            this.getBigStarList()
        },
        methods:{
            learnMore(item){
                window.open(utils.getYouUrl(item.video_id))
            },
            playVideo(item){
                item.isPlay = true
                item.video = this.getYouUri(item.video_id)
                this.$forceUpdate()
            },
            getYouUri(videoId){
                return utils.getYouUri(videoId)
            },
            getBigStarList(){
                this.$api.get_big_star_list({
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.videos.page.current_page,
                }).then(res => {
                    this.videos.list = this.videos.list.concat(res.data.data)
                    this.videos.page.current_page = res.data.current_page
                    this.videos.page.last_page = res.data.last_page
                    this.videos.loading = this.videos.page.current_page >= this.videos.page.last_page ? true : false
                    // this.videos.list.map((v,i) => {
                    //     v.option = this.makePlayerOptions(v)
                    //     this.$set(v,'playVideo',false)
                    //     this.$set(v,'first',true)
                    // })
                })
            },
            downvideo(e){
                this.$utils.handleDownloadUri(e.title,e.video)
            },
            ChangeEmit(){ //子组件传递
                //主动调用子组件
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
            },
            handleScroll () {
                let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if(scrollTop>head_height){
                    // if(scrollTop>this.scroll_height){
                    this.producthea_nav = true
                    // }else{
                    // 	this.producthea_nav = false
                    // }
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop,'pcelites')

                if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
                    if(this.videos.loading){
                        return
                    }
                    this.videos.loading = true
                    this.videos.page.current_page ++
                    this.getBigStarList()
                }
            },
            videoclassall(){
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:1,
                    pageSize:this.videonavnums,
                }
                this.$api.get_video_class_all(data).then((res) => {
                    this.videoclassallss=[
                        {"id":1,"channel_ids":"1,2","name":"操作视频","status":1,"sort":1},
                        {"id":2,"channel_ids":"1,2","name":"病例分享","status":1,"sort":1},
                        {"id":2,"channel_ids":"1,2","name":"产品评价","status":1,"sort":1},
                    ]
                });
            },
            videoclinav(e){
                this.videotopnavind=e
                this.classidd=this.videoclassallss[e].id
                // this.videoclasslist()
            },
            video_in(item){
                let ref = 'videoPlayer'+item.id
                if(item.first){
                    item.first = false
                    this.$refs[ref][0].player.src(item.video)
                }

                item.playVideo = true
                this.$refs[ref][0].player.play()

            },
            video_out(item){
                item.playVideo = false
                let ref = 'videoPlayer'+item.id
                this.$refs[ref][0].player.src(item.video)
            },
            makePlayerOptions(o){
                return  {
                    //播放速度
                    // playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: true,
                    // 导致视频一结束就重新开始。
                    loop: true,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    // preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [
                        {
                            //类型
                            type: "video/mp4",
                            //url地址
                            src: o.video
                            // src: 'http://1500005852.vod2.myqcloud.com/43843f04vodtranscq1500005852/c696376b387702303543912373/v.f100840.mp4'
                        },
                    ],
                    //你的封面地址
                    poster: o.poster,
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                }
            },
            video_play_click(item){
                window.open(item.video)
            }
        }
    }
</script>

<style >
    .pc-big-star .producthea_nav{
        top: 0;
        position: fixed;
        z-index: 9;
        background-color: #fff;
        background: rgba(255,255,255,.72);
        backdrop-filter: saturate(180%) blur(20px);
    }
    .pc-big-star .videohea{
        width: 1400px;
        /* height: 80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
    }
    .pc-big-star .videohea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .pc-big-star .videohea-right{
        display: flex;


    }
    .pc-big-star .videohea-righttitle{
        max-width: 800px;

        display: flex;

        font-size: 16px;
        flex-wrap: wrap;
        margin-left: -24px;
        color: #5d5f5f;
    }
    .pc-big-star .producthearight-item{
        margin-bottom: 10px;
        cursor: pointer;
        margin-left: 24px;
    }
    .pc-big-star .producthearight-item:first-child{
        margin-left: 0px;
    }
    .pc-big-star .videohea-righticon{
        width: 20px;
        height: 20px;
        margin-left: 9px;
        display: flex;
        align-items: center;
    }
    .pc-big-star .videohea-righticon img{
        width: 100%;
        height: 100%;
    }
    .pc-big-star .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }

    body{
        margin: 0;
        padding: 0;
        background: #fff;
    }
    .pc-big-star .pcproducts{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
    .pc-big-star .pchome-headerss{
        width: 100%;
        position: relative;
        background-size: 100% 100%;
        padding-top:119px;
        box-sizing: border-box;
    }

    .pc-big-star .checse{
        margin-top: 0 !important;
    }
    .pc-big-star .product-title{
        color: #fff;
        margin-top: 249px;
        margin-left: 240px;
    }
    .pc-big-star .title-hea{
        font-size: 20px;
        font-weight: normal;
        letter-spacing: 1px;
    }
    .pc-big-star .title-model{
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 44px;
        font-weight: normal;
        letter-spacing: 2px;
    }
    .pc-big-star .product-but{
        margin-top: 40px;
        font-size: 16px;
        width: 110px;
        height: 46px;
        background: #E31E24;
        border-radius: 23px;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
    }
    /* .header-navss{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .nav-wit{

    }
    .pc-big-star .nav-left{
        width: 100px;
        height: 50px;
    }
    .pc-big-star .nav-left img{
        width: 100%;
        height: 100%;
    }
    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .pc-big-star .nav-center-item:first-child{
        margin-left: 0;
    }
    .pc-big-star .nav-right{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }
    .pc-big-star .nav-right .search{
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-big-star .nav-right .search img{
        width: 100%;
        height: 100%;
    }
    .pc-big-star .nav-right .homename{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-big-star .nav-right .homename img{
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pc-big-star .nav-right .language{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pc-big-star .nav-right .language img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }

    .pc-big-star .bb{
        background: #FAFAFA;
        position: fixed;
        top: 0;
        z-index: 99;
    }
    .pc-big-star .aboutitem-hea{
        margin-top: 80px;
        margin-bottom: 40px;
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 33px;
        letter-spacing: 1px;
    }
    .pc-big-star .aboutitem-fooitem{
        margin-bottom: 10px;
    }
    .pc-big-star .fooitem-left{
        width: 110px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #EAEAEA;
        display: flex;
        align-items: center;
        justify-content: center;


        font-size: 16px;
        font-weight: 400;
        color: #FAFAFA;
        margin-right: 20px;
    }
    .pc-big-star .fooitem-left img{
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }
    .pc-big-star .aboutitem-foosus{
        display: flex;
        margin-bottom: 20px;
    }
    .pc-big-star .fooitem-right{
        font-size: 16px;
        font-weight: 400;
        color: #CCCCCC;
    }
    .pc-big-star .fooitem-cont{
        margin-top: 25px;
        margin-left: 40px;
    }
    .pc-big-star .fooitem-cont:first-child{
        margin-left: 0px;
    }
    .pc-big-star .fooite-img{
        display: flex;
    }
    .pc-big-star .fooite-img img{
        width: 90px;
        height: 90px;
    }
    .pc-big-star .fooite-nam{
        text-align: center;
        margin-top: 20px;
    }
    .pc-big-star .right-tit{
        margin-bottom: 5px;
    }
    .pc-big-star .homefoot{

        height: 94px;
        background: #272727;
        border-top: 2px solid #666;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .pc-big-star .foot-hea{
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
    }
    .pc-big-star .foot-f{
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .pc-big-star .videohea{
        width: 1400px;
        /* height: 80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
    }
    .pc-big-star .videohea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .pc-big-star .videohea-right{
        display: flex;


    }
    .pc-big-star .videohea-righttitle{
        max-width: 800px;

        display: flex;

        font-size: 16px;
        flex-wrap: wrap;
        margin-left: -24px;
        color: #5d5f5f;
    }
    .pc-big-star .producthearight-item{
        margin-bottom: 10px;
        cursor: pointer;
        margin-left: 24px;
    }
    .pc-big-star .producthearight-item:first-child{
        margin-left: 0px;
    }
    .pc-big-star .videohea-righticon{
        width: 20px;
        height: 20px;
        margin-left: 9px;
        display: flex;
        align-items: center;
    }
    .pc-big-star .videohea-righticon img{
        width: 100%;
        height: 100%;
    }
    .pc-big-star .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }
    .pc-big-star .productfoo{
        width: 1400px;
        display: flex;
        flex-direction: column;
        padding: 0 260px;

    }
    .pc-big-star .productfoo-downs{
        font-size: 28px;
        font-weight: 500;
        color: #5d5f5f;
        margin-top: 60px;
        margin-bottom: 60px;
    }

    .pc-big-star .productfoo-shop{
        display: flex;
        flex-wrap: wrap;
        margin-left: -40px;
    }
    .pc-big-star .productfoo-item{
        width: 320px;
        margin-left: 40px;
        margin-bottom: 40px;
    }
    .pc-big-star .shop-video{
        position: relative;
        width: 440px;
        /*height: 180px;*/
        cursor: pointer;
    }
    .pc-big-star .shop-video video{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .pc-big-star .shop-video .poster {
        width: 320px;
        height: 180px;
        position: relative;
    }
    .pc-big-star .shop-video .poster img {
        width: 320px;
        height: 180px;
        border-radius: 20px;
    }
    .pc-big-star .shop-video .poster .play {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .pc-big-star .shopvideo-but{
        position: absolute;
        top: 70px;
        left: 140px;
        width: 40px;
        height: 40px;
        display: flex;
    }
    .pc-big-star .shopvideo-but img{
        width: 100%;
        height: 100%;
    }
    .pc-big-star .video_title_image{
        border-radius: 10px;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .pc-big-star .shop-icon{
        width: 320px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
    }
    .pc-big-star .shopicon-left{
        width: 300px;
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
    }
    .pc-big-star .shopicon-right{
        width: 20px;
        height: 20px;
        margin-right: 12px;
        cursor: pointer;
        display: flex;
    }
    .pc-big-star .shopicon-right img{
        width: 100%;
        height: 100%;
    }
    .pc-big-star .productfoo-more{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 80px;
    }
    .pc-big-star .more-but{
        width: 120px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        color: #999999;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pc-big-star .more-but img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }
    .pc-big-star .vjs-big-play-button{
        left:50% !important;
        top: 50% !important;
        margin-top: -1em ;
        margin-left: -1.5em ;
    }
    .pc-big-star .viotopna{
        color: #D03E3D;
    }

    .pc-big-star .vivideot{
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,.32);
        position: fixed;
        top: 0px;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pc-big-star .vividecont{
        position: relative;
        width: 1200px;
        height: 600px;
    }
    .pc-big-star .vividecont video{
        width: 1200px;
        height: 600px;
    }
    .pc-big-star .el-icon-circle-close{
        font-size: 40px;
        color: #fff;
        position: absolute;
        top: -20px;
        right: -16px;
        cursor: pointer;
    }
    /* .header-nav{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .pc-big-star .nav-wit{

    }
    .pc-big-star .nav-left{
        width: 100px;
        height: 50px;
    }
    .pc-big-star .nav-left img{
        width: 100%;
        height: 100%;
    }
    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .pc-big-star .nav-center-item:first-child{
        margin-left: 0;
    }
    .pc-big-star .nav-right{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }
    .pc-big-star .nav-right .search{
        display: flex;
        align-items: center;
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-big-star .nav-right .search img{
        width: 100%;
        height: 100%;
    }
    .pc-big-star .nav-right .homename{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-big-star .nav-right .homename img{
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pc-big-star .nav-right .language{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pc-big-star .nav-right .language img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }
    .pc-big-star .producthea_nav{
        top: 0;
        position: fixed;
        z-index: 9;
        background-color: #fff;
        background: rgba(255,255,255,.72);
        backdrop-filter: saturate(180%) blur(20px);
    }

    .pc-big-star .shop-video .video-player {
        width: 100%;
    }
    .pc-big-star .shop-video .video-js {
        background-color: #ffffff;
    }
    .pc-big-star .shop-video .video-player .vjs-control-bar,
    .pc-big-star .shop-video .video-player .vjs-big-play-button{
        display: none;
    }
    /* 实操课 start */
    .pc-big-star .productfoo {
        margin-top: 65px;
    }
    /* 实操课 end */
    .pc-big-star .shop-video .you-video{
        display: block;
        width: 320px;
        height: 180px;
        border-radius: 20px;
    }
</style>